/* ==========================================================================
   Speglar det valda Kaching-paketets pris in i kopknappen.
   Lymphoria loser samma sak med tre riktiga varianter och forrenderade
   prisspann. Vi har en variant, sa vi laser priset ur det valda kortet
   i stallet och skriver in det i knappen.

   Gor ingenting alls om Kaching saknas pa sidan.
   ========================================================================== */
(function () {
  'use strict';

  var LABEL_SEL = '.main-product-atc .main-atc__label__text';
  var PRICE_SEL = '.main-product-atc .main-atc-price';
  var CMP_SEL   = '.main-product-atc .main-atc-compare';

  // Kaching byter klassnamn mellan versioner, sa vi provar flera.
  var CARD_SEL = [
    '.kaching-bundles__bar',
    '.kaching-bundles__block',
    '[class*="kaching-bundles"][class*="bar"]',
    '[class*="kaching-bundles"][class*="block"]'
  ].join(',');

  var SELECTED = ['--selected', '--active', 'is-selected', 'is-active', 'selected', 'active'];

  function isSelected(el) {
    if (el.getAttribute('aria-checked') === 'true') return true;
    if (el.querySelector('input[type=radio]:checked')) return true;
    var c = el.className || '';
    for (var i = 0; i < SELECTED.length; i++) {
      if (c.indexOf(SELECTED[i]) !== -1) return true;
    }
    return false;
  }

  // plockar ut belopp ur en text, t.ex. "891,00 kr" -> "891,00 kr"
  var MONEY = /\d[\d\s .]*[,.]?\d*\s*(kr|SEK|:-)/i;

  function readPrices(card) {
    var now = null, was = null;
    var strike = card.querySelector('s, del, [class*="full-price"], [class*="compare"]');
    if (strike) {
      var m = (strike.textContent || '').match(MONEY);
      if (m) was = m[0].trim();
    }
    var cand = card.querySelectorAll('[class*="price"]');
    for (var i = 0; i < cand.length; i++) {
      var el = cand[i];
      if (strike && (el === strike || strike.contains(el) || el.contains(strike))) continue;
      var mm = (el.textContent || '').match(MONEY);
      if (mm) { now = mm[0].trim(); break; }
    }
    if (!now) {
      var all = (card.textContent || '').match(new RegExp(MONEY.source, 'gi'));
      if (all && all.length) now = all[0].trim();
      if (all && all.length > 1 && !was) was = all[1].trim();
    }
    return { now: now, was: was };
  }

  function apply() {
    var cards = document.querySelectorAll(CARD_SEL);
    if (!cards.length) return;

    var picked = null;
    for (var i = 0; i < cards.length; i++) {
      if (isSelected(cards[i])) { picked = cards[i]; break; }
    }
    if (!picked) picked = cards[0];

    var p = readPrices(picked);
    if (!p.now) return;

    var priceEl = document.querySelector(PRICE_SEL);
    var cmpEl   = document.querySelector(CMP_SEL);
    var label   = document.querySelector(LABEL_SEL);
    if (!label) return;

    if (!priceEl) {
      priceEl = document.createElement('span');
      priceEl.className = 'main-atc-price';
      label.parentNode.insertBefore(priceEl, label.nextSibling);
    }
    priceEl.textContent = '– ' + p.now;

    if (p.was && p.was !== p.now) {
      if (!cmpEl) {
        cmpEl = document.createElement('s');
        cmpEl.className = 'main-atc-compare';
        priceEl.parentNode.insertBefore(cmpEl, priceEl.nextSibling);
      }
      cmpEl.textContent = p.was;
      cmpEl.hidden = false;
    } else if (cmpEl) {
      cmpEl.hidden = true;
    }
  }

  var timer = null;
  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(apply, 60);
  }

  function start() {
    if (!document.querySelector(CARD_SEL)) return;
    apply();
    document.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest(CARD_SEL)) schedule();
    }, true);
    document.addEventListener('change', schedule, true);
    var host = document.querySelector('[class*="kaching-bundles"]');
    if (host && window.MutationObserver) {
      new MutationObserver(schedule).observe(host, {
        subtree: true, attributes: true, childList: true,
        attributeFilter: ['class', 'aria-checked', 'checked']
      });
    }
  }

  // Kaching injiceras efter DOMContentLoaded, sa vi vantar in det.
  function boot() {
    var tries = 0;
    var iv = setInterval(function () {
      tries++;
      if (document.querySelector(CARD_SEL)) { clearInterval(iv); start(); }
      else if (tries > 40) clearInterval(iv);   // ger upp efter ~10 s
    }, 250);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
